import { Component, Input } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { SimLogResultEntry } from 'src/modules/enaio/shared/SimLogResultEntry';
import { SimLogSearchOptions } from 'src/modules/enaio/shared/SimLogSearchOptions';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { Progressor } from 'src/modules/utils/misc/Progressor';
import { Wrapper } from 'src/modules/utils/misc/wrapper.model';
import { DhTools } from '../../models/dh-tools.model';
import { Utils } from 'src/modules/utils/shared/utils';
import { TableColumn } from 'src/modules/sm-base/models/table-column.model';
import { TableCellType } from 'src/modules/sm-base/models/table-cell-type.enum';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableSortColumn } from 'src/modules/sm-base/models/table-sort-column.model';
import { DocumentHandlerMainComponent } from '../document-handler-main/document-handler-main.component';

@Component({
  selector: 'app-sim-log-result',
  templateUrl: './sim-log-result.component.html',
  styleUrl: './sim-log-result.component.scss'
})
export class SimLogResultComponent extends ComponentView {

    _searchOptions: SimLogSearchOptions;

    result: SimLogResultEntry[];
    resultTable: TableData;
    
    actionButtons: MenuItem[];
    progressor = new Wrapper<Progressor>();
        
    @Input()
    set searchOptions(value: SimLogSearchOptions) {
        this._searchOptions = value;
        this.run();
    }

    async initParams(): Promise<boolean> {
        return true;
    }

    async run(): Promise<void> {
        DhTools.startProgressor(this.progressor, await DhTools.backendCall("api/dh/simLogSearch", { options: this._searchOptions }).getText(), async result => {
            this.result = Utils.fromPlainArray(SimLogResultEntry, Utils.fromJson(result.value) as any[]);
            this.resultTable = new TableData([
                new TableColumn("date", "Datum", TableCellType.dateTime, { autoWidth: 1 }),
                new TableColumn("fileName", "Dateiname", TableCellType.text, { autoWidth: 30 }),
                new TableColumn("configName", "Konfiguration", TableCellType.text, { autoWidth: 30 }),
                new TableColumn("id", "Objekt-ID", TableCellType.text, { autoWidth: 40 }),
                new TableColumn("value", "Wert", TableCellType.text, { flex: 1 })
            ], this.result.map(entry => new TableRow("", entry, {
                date: entry.date,
                fileName: Utils.getFileNameWithoutPath(entry.fileName),
                configName: entry.configName,
                id: entry.id,
                value: entry.value
            }), [new TableSortColumn("date")]));
            this.actionButtons = await DocumentHandlerMainComponent.instance?.generateContextMenu(Utils.arrayItemsToString(this.result, "\n", entry => entry.value));
        });
    }

    async createConfig(): Promise<void> {
        let s = Utils.toJson(this._searchOptions, true);
        s = "{\n  \"source\": {\n    \"type\": \"SimLog\",\n    \"options\": " + Utils.replaceAll(s, "\n", "\n    ") + "\n  }\n}";
        this.app.messageDialog.textArea("Vorlage", s, null, true);
    }
}
